import PropTypes from "prop-types";
import { Alert, Box, Stack, Typography } from "@mui/material";
import DeviceActionDialog from "./DeviceActionDialog";
export default function ResetScopeDialog({
  open,
  onClose,
  onConfirm,
  title,
  scope,
  readers,
  loading,
  progress,
  skipWaiting = false,
}) {
  const active = readers.filter((reader) => reader.status);
  const waiting = readers.filter((reader) => reader.isOnCooldown);
  const eligible = active.filter((reader) => !reader.isOnCooldown);
  const blocked = !skipWaiting && waiting.length > 0;
  return (
    <DeviceActionDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      subtitle={scope}
      actionLabel={`Reiniciar ${skipWaiting ? eligible.length : active.length} readers`}
      loading={loading}
      disabled={!active.length || blocked || (skipWaiting && !eligible.length)}
      progress={progress}
      fields={[
        ["Alcance", scope],
        ["Readers activos", active.length],
        ["Readers registrados", readers.length],
        ["En espera de 5 minutos", waiting.length],
        ["Comercios", new Set(readers.map((reader) => reader.commerce).filter(Boolean)).size],
      ]}
    >
      {waiting.length > 0 && (
        <Alert severity="info" sx={{ mb: 2 }}>
          {skipWaiting
            ? `${
                waiting.filter((reader) => reader.status).length
              } readers activos se omitirán porque están en espera.`
            : "Hay readers en espera. El reinicio de todo el alcance se habilitará cuando terminen sus 5 minutos."}
        </Alert>
      )}
      <Alert severity="warning" sx={{ mb: 2 }}>
        La operación afecta a los dispositivos del alcance indicado, incluidos los que no están
        visibles en la página actual.
      </Alert>
      <Typography variant="body2" fontWeight={700} mb={1}>
        Readers activos del alcance
      </Typography>
      <Box
        sx={{
          maxHeight: 220,
          overflow: "auto",
          border: "1px solid #dfe6ed",
          borderRadius: 1.5,
          bgcolor: "#fff",
        }}
      >
        {active.length ? (
          active.map((reader, index) => (
            <Stack
              key={`${reader.id}-${index}`}
              direction="row"
              justifyContent="space-between"
              gap={1}
              sx={{ p: 1.5, borderBottom: "1px solid #edf1f5" }}
            >
              <Box>
                <Typography variant="body2" fontWeight={600}>
                  {reader.hostname}
                </Typography>
                <Typography variant="caption" sx={{ color: "#526579" }}>
                  {reader.commerce || "Sin comercio"}
                  {reader.isOnCooldown ? " · En espera" : ""}
                </Typography>
              </Box>
              <Typography variant="caption" sx={{ color: "#526579", whiteSpace: "nowrap" }}>
                {reader.ip || "Sin IP"}
              </Typography>
            </Stack>
          ))
        ) : (
          <Typography variant="body2" sx={{ p: 2 }}>
            No hay readers activos para esta operación.
          </Typography>
        )}
      </Box>
    </DeviceActionDialog>
  );
}
ResetScopeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
  readers: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  progress: PropTypes.object,
  skipWaiting: PropTypes.bool,
};
